/* eslint-disable no-undef */
/* eslint-disable block-spacing */
/* eslint-disable space-before-function-paren */
/* eslint-disable brace-style */
/* eslint-disable space-before-blocks */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable space-in-parens */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-trailing-spaces */
/* eslint-disable eol-last */
/* eslint-disable semi */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable indent */

// npm install axios --save
// npm install qs

import $com from '../assets/js/common.js'
import axios from 'axios'
// import Qs from 'qs'
// import router from '../router'
// import { Toast, Dialog } from 'vant'
import { Message } from 'element-ui'

// 环境的切换
if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = $com.root + '/interface/'
} else if (process.env.NODE_ENV == 'debug') {
  axios.defaults.baseURL = $com.root + '/interface/'
} else if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = $com.root + '/interface/'
}

// 设置请求超时时间
axios.defaults.timeout = 30000

// 设置post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'


// 请求拦截
// 请求拦截 和响应拦截可以加loading状态 请求展示 响应隐藏
axios.interceptors.request.use( config => {
  // 在发送请求之前做些什么 验证token之类的
  // const token = localStorage.getItem('token') || ''
  // const identity = localStorage.getItem('identity') || 'visitor'
  // // console.log(token)
  // if (token) {
  //   // 有token 取缓存
  //   config.headers.Auth = `${token}`
  //   config.headers.Role = `${identity}`
  //   return config
  // } else {
  //   // 没token 去生成
  //   // const token = $com.sjToken()
  //   // config.headers.Auth = `${token}`;
  //   return config
  // }
  return config
}, error => {
  // 对请求错误做些什么
  return Promise.error(error)
})

// 响应拦截
axios.interceptors.response.use( response => {
    // 对响应数据做点什么
    return response;
  }, error => {
    // 对响应错误做点什么
    return Promise.reject(error);
  });

// 封装get方法和post方法

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
// export function get(url, params){
//   return new Promise((resolve, reject) => {
//     axios.get(url, { params: params }).then(res => {
//       const data = res.data
//       if (data.code === 1) {
//         // Toast.success(data.warn)
//         resolve(data)
//       } else {
//         if (data.warn === '你未登录，请登录' || data.warn === 'Auth 已失效，请重新登录' || data.code === -1) {
//           if (router.currentRoute.path !== '/login') {
//             Dialog.alert({
//               title: '温馨提示',
//               message: '登录失效，请重新登录',
//               confirmButtonColor: $com.themeColor,
//               confirmButtonText: '去登录'
//             }).then(() => {
//               // on close
//               localStorage.clear()
//               const stamp = new Date().getTime()
//               router.push({ path: '/', query: { crc: stamp } })
//               // router.push({ path: '/' })
//               // if (router.currentRoute.path === '/') {
//               //   const url = window.location.href
//               //   window.location.href = url
//               // } else {
//               //   router.push({ path: '/' })
//               // }
//             })
//           }
//         } else {
//           Toast.clear()
//           Toast(data.warn)
//         }
//       }
//     }).catch(err => {
//       Toast.clear()
//       Toast(err)
//       reject(err.data)
//     })
//   })
// }

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
/* export function post(url, params) {
  return new Promise((resolve, reject) => {
    // params.token = '3222'
    // params = params + ',token=' + '333'
    // console.log(params)
    // const data = Qs.stringify(params)
    axios.post(url, Qs.stringify(params))
      .then(res => {
        const data = res.data
        if (data.code === 1) {
          // Toast.success(data.warn)
          resolve(data)
        } else {
          if (data.warn === '你未登录，请登录' || data.warn === 'Auth 已失效，请重新登录') {
            if (router.currentRoute.path !== '/') {
              Dialog.alert({
                title: '温馨提示',
                message: data.warn,
                confirmButtonColor: $com.themeColor
              }).then(() => {
                // on close
                router.push({ path: '/' })
              })
            }
          } else {
            Toast.fail(data.warn)
          }
        }
      })
      .catch(err => {
        Toast(err)
        reject(err.data)
      })
  })
} */

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, data = {}) {
  const formData = new FormData()
  Object.keys(data).forEach(key => formData.append(key, data[key]))
  // for (let i = 0, len = Object.keys(data).length; i < len; i++) {
  //   formData.append(Object.keys(data)[i], data[Object.keys(data)[i]])
  // }
  return new Promise((resolve, reject) => {
    axios.post(url, formData)
      .then(res => {
        const data = res.data
        if (data.code === 1) {
          // Toast.success(data.warn)
          resolve(data)
        } else {
          Message(data.warn)
          // if (data.warn === '你未登录，请登录' || data.warn === 'Auth 已失效，请重新登录') {
          //   if (router.currentRoute.path !== '/login') {
          //     Dialog.alert({
          //       title: '温馨提示',
          //       message: '登录失效，请重新登录',
          //       confirmButtonColor: $com.themeColor,
          //       confirmButtonText: '去登录'
          //     }).then(() => {
          //       // on close
          //       // router.push({ path: '/login' })
          //       localStorage.clear()
          //       const stamp = new Date().getTime()
          //       router.push({ path: '/', query: { crc: stamp } })
          //       // if (router.currentRoute.path === '/') {
          //       //   const url = window.location.href
          //       //   window.location.href = url
          //       // } else {
          //       //   router.push({ path: '/' })
          //       // }
          //     })
          //   }
          // } else {
          //   Toast.clear()
          //   Toast(data.warn)
          // }
        }
      })
      .catch(err => {
        // Toast.clear()
        // Toast(err)
        reject(err.data)
      })
  })
}
